// import { lazy } from "react";

import EmployeeLogin from "../pages/Auth/employeeLogin";

//Dashboard
import Dashboard from "../pages/Dashboard/index";
import NotFound from "../pages/NotFoundPage/index";
import InAppNotifications from "../pages/Notifications/InAppNotifications/InAppNotifications";
import PushNotification from "../pages/Notifications/PushNotifications";

//Reports
import ManageOrganization from "../pages/Organization";
import TicketingDetails from "../pages/Ticketing";
import AccessDetails from "../pages/UserManagement/access";
import MenuDetails from "../pages/UserManagement/menu";
import UserPermissionDetails from "../pages/UserManagement/user-permission";
import UserRoleDetails from "../pages/UserManagement/user-role";

//Auth protected routes
const authProtectedRoutes = [
  { path: "/dashboard", exact: true, component: Dashboard },
  { path: "/not-found", exact: true, component: NotFound },

  //Reports
  {
    path: "/manage-organization",
    exact: true,
    component: ManageOrganization,
  },

  //ticketing

  {
    path: "/ticketing",
    exact: true,
    component: TicketingDetails,
  },
  {
    path: "/user/access",
    exact: true,
    component: AccessDetails,
  },
  {
    path: "/user/menu",
    exact: true,
    component: MenuDetails,
  },
  {
    path: "/user/role",
    exact: true,
    component: UserRoleDetails,
  },
  {
    path: "/user/permission",
    exact: true,
    component: UserPermissionDetails,
  },
    {
    path: "/in-app-notification",
    exact: true,
    component:InAppNotifications,
  },
  {
    path: "/push-notification",
    exact: true,
    component:PushNotification,
  },
];

const publicRoutes = [
  { path: "/", exact: true, component: EmployeeLogin },
  { path: "/login", component: EmployeeLogin },
];

export { authProtectedRoutes, publicRoutes };
